<template>
  <div class="mt-12">
    <button
      class="btn btn_dark-soft btn_sm border-radius-md px-8"
      @click="openVideoCall()"
    >
      <span class="icon-20 d-block mr-8">
        <svg>
          <use
            xlink:href="/local/components/orteka/catalog.element/src/assets/img/sprite.svg?t=1733294817#icon-headset"
          ></use>
        </svg>
      </span>
      <span class="d-block"> Видеоконсультант </span>
    </button>
  </div>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

export default {
  name: "ProductVideoCall",
  computed: {
    ...mapState(useProductStore, ["isVideoCallAvailable"]),
  },
  methods: {
    openVideoCall() {
      window.openCallPopup();
    },
  },
};
</script>
